import { TextField } from '../ui/TextField';
import { normalizeNickname } from '../../lib/mappingNickname';

// Optional handle for a new integration. It is permanent (see
// lib/mappingNickname.ts), so say what it is used for.
export function NicknameField({ value, onChange, example }: { value: string; onChange: (v: string) => void; example: string }) {
  const shown = normalizeNickname(value);
  return (
    <div className="flex flex-col gap-1">
      <TextField
        label="Nickname (optional)"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={example}
        className="font-mono"
        autoCapitalize="off"
        autoCorrect="off"
        spellCheck={false}
      />
      <span className="text-xs text-black/45 dark:text-white/45">
        {shown && shown !== value.trim() ? (
          <>
            Will be saved as <code className="font-mono">{shown}</code>.{' '}
          </>
        ) : null}
        Used in <code className="font-mono">zagentc import --mapping …</code> and can't be changed later. Blank = generated.
      </span>
    </div>
  );
}
